module.exports = __webpack_public_path__ + "static/img/tape5.17340a04.png";